import { useCallback, useEffect, useState } from 'react'
import { useStore } from '../../store'
import { authedAxios } from '../../utils'

import { COMPANY_CONFIG_ACTIONS } from '../../store/companyConfig'

const useCompanyConfig = () => {
  const { state, dispatch } = useStore()
  const { companyConfig, companyConfigExp } = state

  const [isLoading, setIsLoading] = useState(true)
  const [hasLoadError, setHasLoadError] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [localCopy, setLocalCopy] = useState(null)

  const commitToStore = (data) =>
    dispatch({
      type: COMPANY_CONFIG_ACTIONS.SET_COMPANY_CONFIG,
      companyConfig: data,
    })

  const getCompanyConfig = () => {
    if (companyConfig && Date.now() < companyConfigExp) {
      setLocalCopy(companyConfig)
      return setIsLoading(false)
    }

    return authedAxios
      .get('/api/company/config')
      .then((res) => {
        const newValue = { ...companyConfig, ...res.data.companyConfig }
        commitToStore(newValue)
        setLocalCopy(newValue)
      })
      .catch((e) => {
        setHasLoadError(true)
      })
      .finally(() => setIsLoading(false))
  }

  const updateCompanyConfig = (input) => {
    const newCompanyConfig = input || localCopy
    commitToStore(newCompanyConfig)
    setIsSubmitting(true)
    return authedAxios
      .put('/api/company/config', newCompanyConfig)
      .finally(() => {
        setIsSubmitting(false)
      })
  }

  const patchUpdateCompanyConfig = (partialInput) => {
    const newCompanyConfig = { ...companyConfig, ...partialInput }
    return updateCompanyConfig(newCompanyConfig)
  }

  useEffect(() => {
    getCompanyConfig()
  }, [])

  return {
    companyConfig: localCopy,
    setCompanyConfig: setLocalCopy,
    updateCompanyConfig,
    patchUpdateCompanyConfig,
    companyConfigStoreCopy: companyConfig,
    isLoading,
    isSubmitting,
    hasLoadError,
  }
}

export default useCompanyConfig
